module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO CONTRATOS CIVILES.9f2e1e44.pdf";